import React from "react";
import { motion } from "framer-motion";
import { Link as RouterLink } from "react-router-dom";
import { FaMicrochip, FaCar, FaBolt, FaDraftingCompass, FaTools, FaShieldAlt } from "react-icons/fa";

const applicationsData = [
  {
    icon: <FaMicrochip />,
    title: "Electronics & PCB Assembly",
    description: "High-purity Tin Ingots, Solder Wires, and Solder Paste are vital for surface-mount technology (SMT), wave soldering, and hand soldering of printed circuit boards (PCBs) in consumer electronics, industrial automation, and telecom gear.",
    products: ["Industrial Solder Wire", "Solder Paste", "Solder Stick (63/37)", "Tin Ingots"]
  },
  {
    icon: <FaBolt />,
    title: "Electrical Transmission & Transformers",
    description: "High electrical conductivity Copper Round Bars, Copper Flats, and specialized soldering alloys ensure minimal energy loss, robust busbar connections, and long-term durability in power transformers, switchgear panels, and electric motors.",
    products: ["Copper Round Bar", "Copper Axe", "Solder Stick", "Tin Ingots"]
  },
  {
    icon: <FaCar />,
    title: "Automotive & Transportation",
    description: "Our soldering alloys, radiator solder sticks, and wire harnesses provide heat resistant and vibration-proof metal bonding for automotive wiring systems, heat exchangers, and vehicle battery modules.",
    products: ["Solder Wire", "Star Solder Stick", "Lead Ingots", "Copper Bar"]
  },
  {
    icon: <FaShieldAlt />,
    title: "Battery Manufacturing & Shielding",
    description: "Refined pure Lead Ingots are extensively used in lead-acid battery plate casting, chemical storage tank lining, cable jacketing, and medical radiation shielding in X-ray and radiology facilities.",
    products: ["Lead Ingots", "Refined Lead Ingot Bars"]
  },
  {
    icon: <FaTools />,
    title: "Plumbing, Sheet Metal & Joining",
    description: "Star solder sticks and small solder ingots provide reliable metal joining for copper pipe plumbing, brassware manufacturing, sheet metal fabrication, and heat exchanger assembly.",
    products: ["Star Solder Stick", "Small Solder Ingot", "Long Solder Ingot"]
  }
];

const ApplicationsPg = () => {
  return (
    <div className="page-wrapper">
      <section className="page-banner">
        <div className="page-banner-container">
          <h1>Industrial Applications</h1>
          <p>Key Industries Served by JK Metal &amp; Alloys Across India</p>
        </div>
      </section>

      <section className="applications-section">
        <div className="container">
          <div className="section-header center">
            <span className="sub-title">Versatile Metal Solutions</span>
            <h2>Powering Diverse Industrial Sectors</h2>
            <p>Our metals and soldering alloys meet stringent technical standards required across modern engineering and manufacturing sectors.</p>
          </div>

          <div className="applications-grid">
            {applicationsData.map((app, i) => (
              <motion.div 
                className="app-card" 
                key={i}
                whileHover={{ y: -8 }}
                transition={{ duration: 0.3 }}
              >
                <div className="app-icon">{app.icon}</div>
                <h2>{app.title}</h2>
                <p>{app.description}</p>
                <div className="app-products-list">
                  <strong>Recommended Products:</strong>
                  <ul>
                    {app.products.map((p, idx) => (
                      <li key={idx}>✓ {p}</li>
                    ))}
                  </ul>
                </div>
                <RouterLink to="/product-enquiry" className="app-enquire-link">
                  Request Solution Quote &rarr;
                </RouterLink>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="page-cta-bar">
        <div className="container center">
          <h2>Have a Specific Industrial Technical Specification?</h2>
          <p>Consult with our metallurgists in Ahmedabad for custom alloy compositions and sample batches.</p>
          <RouterLink to="/contact-us" className="btn-gold">Consult With Our Team</RouterLink>
        </div>
      </section>
    </div>
  );
};

export default ApplicationsPg;